import PropertyParallaxContainer from "../../../components/property/other/propertyParallax";

const PropertyParallax = () => {
  return <PropertyParallaxContainer />;
};

export default PropertyParallax;
